// CTC argmax + merge utilities.
//
// Kept deliberately split so that streaming/chunked decoding (engine.js)
// can stitch per-window argmax sequences before running the repeat-collapse
// pass — otherwise repeats that span a chunk boundary would be lost.

export function ctcArgmax(logits, timeSteps, vocabSize) {
  const out = new Int32Array(timeSteps);
  for (let t = 0; t < timeSteps; t += 1) {
    out[t] = argmaxRow(logits, t * vocabSize, vocabSize);
  }
  return out;
}

export function ctcMerge(argmaxSeq, blankId) {
  const tokens = [];
  let prev = -1;
  for (let i = 0; i < argmaxSeq.length; i += 1) {
    const id = argmaxSeq[i];
    if (id !== blankId && id !== prev) tokens.push(id);
    prev = id;
  }
  return tokens;
}

function argmaxRow(logits, offset, vocabSize) {
  let best = -Infinity;
  let bestIdx = 0;
  for (let v = 0; v < vocabSize; v += 1) {
    const p = logits[offset + v];
    if (p > best) {
      best = p;
      bestIdx = v;
    }
  }
  return bestIdx;
}
